import type { SVGProps } from 'react';
const SvgPhoneInTalk = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="3 3 18 18"
    {...props}
  >
    <g clipPath="url(#phone_in_talk_svg__a)">
      <path
        fill="currentColor"
        d="M20 15.5c-1.25 0-2.45-.2-3.57-.57a1.02 1.02 0 0 0-1.02.24l-2.2 2.2a15.045 15.045 0 0 1-6.59-6.59l2.2-2.21a.96.96 0 0 0 .25-1A11.36 11.36 0 0 1 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1ZM19 12h2a9 9 0 0 0-9-9v2c3.87 0 7 3.13 7 7Zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3Z"
      ></path>
    </g>
    <defs>
      <clipPath id="phone_in_talk_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
export default SvgPhoneInTalk;
